<template>
   <div class="card mt-2 text-left p-3 bg-light border border-white" :class="classCustom">
    <p class="mb-2">
      <span>
        <img
          width="35px"
          class="rounded-circle d-inline"
          src="@/assets/images/oliver-b-1.png"
          alt=""
        />
      </span>
      <strong class="ml-2">Tips</strong>
    </p>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'Tips',
  props: {
    message: {
      type: String,
      default: ''
    },
    classCustom: {
      type: String,
      default: ''
    }
  },

  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
</style>
